<template>
    <div v-if="Object.keys(data).length > 0" class="company-announcement">
        <div class="banner-wrap">
            <div class="title">{{ data.title }}</div>
            <img class="banner" :src="data.mobileBanner.url" :alt="data.title" />
        </div>
        <div class="content">
            <div class="content-wrap">
                <iframe :src="data.iframe.url" frameborder="0" width="100%" height="1450px"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'

export default {
    name: 'CompanyAnnouncement',
    components: {},
    data() {
        return {
            data: {}
        }
    },
    computed: {},
    created() {
        ajax.investorAnnouncement().then(res => {
            this.data = res
        })
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.company-announcement {
    .banner-wrap {
        height: 480px;
        position: relative;
        .title {
            font-weight: 500;
            font-size: 60px;
            color: #ffffff;
            position: absolute;
            left: 40px;
            top: 80px;
        }
        .banner {
            width: 100%;
            height: 100%;
            display: block;
        }
    }
    .content {
        padding: 40px 40px 0 40px;
        .content-wrap {
            /* margin-bottom: 60px; */
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/company-announcement.vue